var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationActive = function SvgNotificationActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C70EE",
    fillRule: "evenodd",
    d: "M11 3.566V2h2v1.566c3.67.489 6.5 3.63 6.5 7.434v5.5H21v2H3v-2h1.5V11A7.5 7.5 0 0 1 11 3.566M15.5 20v2h-7v-2z",
    clipRule: "evenodd"
  })));
};
export { SvgNotificationActive as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExIDMuNTY2MDlMMTEgMkgxM0wxMyAzLjU2NjA5QzE2LjY2OTQgNC4wNTQ5OCAxOS41IDcuMTk2OTIgMTkuNSAxMVYxNi41SDIxVjE4LjVIM1YxNi41SDQuNVYxMUM0LjUgNy4xOTY5MiA3LjMzMDY0IDQuMDU0OTggMTEgMy41NjYwOVpNMTUuNSAyMFYyMkg4LjVWMjBIMTUuNVoiIGZpbGw9IiMxQzcwRUUiLz4KPC9zdmc+";